var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row page-break justify-content-center mb-0 mt-0"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"h-line page-break"})])])
}]

export { render, staticRenderFns }